module.exports = __webpack_public_path__ + "static/w3-carousel-autoRotate-5518017a69342ce914a266b004dab140.png";